import Req from '../../$axios';

const serviceModule = {
  // 查询应用概览
  getAppOverview(params) {
    return Req(
      {
        url: `user-analysis-cms/stat/getAppOverview`,
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 获取跨团队项目列表
  getCrossProjects(params) {
    return Req(
      {
        url: `crossProjects/index`,
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 新建跨团队项目
  saveCrossProjects(params) {
    return Req(
      {
        url: `crossProjects/save`,
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 跨团队项目审核
  crossProjectsApproval(params) {
    return Req(
      {
        url: `crossProjects/approval`,
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 跨团队项目详情
  readCrossProjects(params) {
    return Req(
      {
        url: `crossProjects/read`,
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 跨团队项目更新
  updateCrossProjects(params) {
    return Req(
      {
        url: `crossProjects/update`,
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 跨团队项目更新状态
  changeCrossProjectsStatus(params) {
    return Req(
      {
        url: `crossProjects/updateCrossProjectStatus`,
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 获取部门分类
  departmentCategoryIndex(params) {
    return Req(
      {
        url: `project/departmentCategoryIndex`,
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 获取业务分类
  businessCategoryIndex(params) {
    return Req(
      {
        url: `project/businessCategoryIndex`,
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  getNumberOfCrossProjects(params) {
    return Req(
      {
        url: `crossProjects/getNumberOfCrossProjects`,
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 获取跨团队项目进度详情
  getCrosssProjectsDetail(params) {
    return Req(
      {
        url: 'crossProjects/progressOverview',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 获取跨团队项目成员
  getCrossProjectsMembers(params) {
    return Req(
      {
        url: 'crossProjects/getCrossProjectMembers',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 设置项目管理员
  setCrossProjectsAdmin(params) {
    return Req(
      {
        url: 'crossProjects/setAdmin',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 新增项目成员
  addCrossProjectsMember(params) {
    return Req(
      {
        url: 'crossProjects/addMembersToCrossProject',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 删除项目成员
  delCrossProjectsMember(params) {
    return Req(
      {
        url: 'crossProjects/deleteMembersToCrossProject',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },

  managementIndex(params) {
    return Req(
      {
        url: `crossProjects/managementIndex`,
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 新建里程碑
  addCrossProjectMilepost(params) {
    return Req(
      {
        url: 'crossProjectsMilestone/save',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 修改里程碑
  editCrossProjectMilepost(params) {
    return Req(
      {
        url: 'crossProjectsMilestone/update',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 删除里程碑
  delCrossProjectMilepost(params) {
    return Req(
      {
        url: 'crossProjectsMilestone/delete',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 查看里程碑
  checkCrossProjectMilepost(params) {
    return Req(
      {
        url: 'crossProjectsMilestone/read',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  updateCrossProjectStatus(params) {
    return Req(
      {
        url: `crossProjects/updateCrossProjectStatus`,
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 更新里程碑状态
  changeCrossProjectMilepost(params) {
    return Req(
      {
        url: 'crossProjectsMilestone/updateStatus',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  getPermissionIndex(params) {
    return Req(
      {
        url: `crossProjects/getPermissionIndex`,
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 获取未加入跨团队项目子项目
  getSubprojects(params) {
    return Req(
      {
        url: 'project/getTheUnJoinCrossProjectsList',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 创建子项目
  createSubproject(params) {
    return Req(
      {
        url: 'project/saveSubproject',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 添加或移除子项目
  addDelSubproject(params) {
    return Req(
      {
        url: 'crossProjects/JoinOrRemoveTheCrossProject',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 我的任务获取我未完成的任务
  getMyUnfinishTaskOfTheProjectList(params) {
    return Req(
      {
        url: 'project/getMyUnfinishTaskOfTheProjectList',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 星标项目
  getprojectMarkStarList(params) {
    return Req(
      {
        url: 'project/getprojectMarkStarList',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 星标项目排序
  updateProjectMarkStarSort(params) {
    return Req(
      {
        url: '/projectMarkStar/updateProjectMarkStarSort',
        method: 'post',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 近期访问的项目
  getProjectBrowseHistoryList(params) {
    return Req(
      {
        url: 'project/getProjectBrowseHistoryList',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 近期变动的项目
  getRecentUpdateProjectList(params) {
    return Req(
      {
        url: 'project/getRecentUpdateProjectList',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 近期变动的项目
  markStarToTheProject(params) {
    return Req(
      {
        url: 'project/markStarToTheProject',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  }
}
export default {
  ...serviceModule
};
